export default "__VITE_ASSET__0a68688c__"